<template>
  <div class="echarts-box">
    <div ref="echartRef" class="charts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'

export default {
  name: 'Echarts',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dom: null,
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          this.setOptions({ animation: false, ...val })
        })
      },
    },
  },
  mounted() {
    this.dom = echarts.init(this.$refs.echartRef)

    this.dom.on('click', (param) => {
      this.$emit('click', param)
    })

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 清理图表实例和监听器
    if (this.dom) {
      echarts.dispose(this.dom)
      this.dom = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    setOptions(options) {
      if (this.dom) {
        this.dom.clear()
        this.dom.setOption(options)
      }
    },
    handleResize() {
      if (this.dom) {
        this.dom.resize()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.echarts-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.charts {
  width: 100%;
  height: 100%;
}
</style>